import { memo, useMemo } from 'react';
import type { ClearTagsButtonProps as Props } from './types';
import { useRenderClearButton } from './use-render-clear-button';

export const ClearTagsButton = memo(({ type, onClick, text, count }: Props) => {
  const buttonProps = useMemo(
    () => ({ onClick, text, count }),
    [onClick, text, count]
  );
  const component = useRenderClearButton(type, buttonProps);
  return component ?? null;
});

ClearTagsButton.displayName = 'ClearTagsButton';
